import { Outlet } from "react-router-dom";

export default function ProbesLayout() {
    return (
        <Outlet />
    )
}